import { render, staticRenderFns } from "./addPurchaseModal.vue?vue&type=template&id=302397dc&scoped=true"
import script from "./addPurchaseModal.vue?vue&type=script&lang=js"
export * from "./addPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302397dc",
  null
  
)

export default component.exports